
import React from "react";

interface FormHeaderProps {
  title: string;
  subtitle?: string;
}

const FormHeader: React.FC<FormHeaderProps> = ({
  title,
  subtitle
}) => {
  return (
    <div className="text-center">
      <h2 className="text-2xl font-bold text-grandpal-green-dark">{title}</h2>
      {subtitle && <p className="text-gray-600 mt-2">{subtitle}</p>}
    </div>
  );
};

export default FormHeader;

